import { render, staticRenderFns } from "./need.vue?vue&type=template&id=afeb4294&scoped=true"
import script from "./need.vue?vue&type=script&lang=js"
export * from "./need.vue?vue&type=script&lang=js"
import style0 from "./need.vue?vue&type=style&index=0&id=afeb4294&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afeb4294",
  null
  
)

export default component.exports